import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Button, Row, Col } from 'bootstrap';

import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';

import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import ModalHelper from './modalHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import DurationPicker from 'shared/components/pickers/durationPicker.jsx';
import DurationMuteIcon from 'main/components/show/cuesheet/durationMuteIcon.jsx';
import DurationSuppressionIcon from 'main/components/show/cuesheet/durationSuppressionIcon.jsx';

/**
 * Duration Picker Modal component
 *
 */
export default React.createClass({
  mixins: [
    PureRenderMixin,
    Reflux.connectFilter(
      CuesheetStore,
      'rowState',
      ModalHelper.itemConnectFilter(
        (row) =>
          row.getIn(['editing', 'type']) === EditableCellTypes.ItemDuration,
      ),
    ),
    Reflux.connectFilter(CuesheetResponsiveStore, 'modalFields', (st) =>
      st.getIn(['modal', 'fields']),
    ),
  ],

  displayName: 'ItemDurationModal',

  render() {
    return (
      <Modal
        className="csr-modal-item-timer-wrapper"
        name={this._getModalId()}
        onHide={() => CuesheetCellActions.cancelEditing()}
        title="Duration"
      >
        <div className="csr-modal-item-timer-content">
          {this._getDurationPickerNode()}
          {this._getAdditionalControlsNode()}
          <Button onClick={this._handleDone}>Save</Button>
        </div>
      </Modal>
    );
  },

  _getAdditionalControlsNode() {
    const { rowState } = this.state;

    if (!rowState || !rowState.item) return null;

    return (
      <Row>
        <Col xs={24}>
          <div className="text-center">
            <DurationMuteIcon
              withTooltip
              isSuppressed={this._getSuppressedValue()}
              onChange={this._handleDurationSuppressionChange}
            />
            <DurationSuppressionIcon
              withTooltip
              onChange={this._handleItemRunTimeSuppressionChange}
              isRunTimeSuppressed={this._getRunTimeSuppressedValue()}
            />
          </div>
        </Col>
      </Row>
    );
  },

  _getDurationPickerNode() {
    const { rowState } = this.state;

    if (!rowState) return null;

    return (
      <div className="duration-picker">
        <div className="text-center">
          <DurationPicker
            mobile
            value={this._getDurationValue()}
            onChange={this._handleDurationChange}
          />
        </div>
      </div>
    );
  },

  _handleDone() {
    let durationInSeconds = this._getDurationValue(),
      durationSuppressed = this._getSuppressedValue(),
      runTimeClockSuppressed = this._getRunTimeSuppressedValue();

    let changes = {
      durationInSeconds,
    };

    if (typeof durationSuppressed === 'boolean') {
      changes.durationSuppressed = durationSuppressed;
    }

    if (typeof runTimeClockSuppressed === 'boolean') {
      changes.runTimeClockSuppressed = runTimeClockSuppressed;
    }

    CuesheetCellActions.saveItemTimeFields(this._getRowIndex(), changes);

    CuesheetResponsiveActions.clearModalFields();
    ModalActions.hide(this._getModalId());
  },

  _handleDurationChange(duration) {
    CuesheetResponsiveActions.updateModalField('durationInSeconds', duration);
  },

  _handleDurationSuppressionChange(isSuppressed) {
    CuesheetResponsiveActions.updateModalField(
      'durationSuppressed',
      isSuppressed,
    );
  },

  _handleItemRunTimeSuppressionChange(isSuppressed) {
    CuesheetResponsiveActions.updateModalField(
      'runTimeClockSuppressed',
      isSuppressed,
    );
  },

  _getSuppressedValue() {
    return this._getBoolFieldValue('durationSuppressed');
  },

  _getRunTimeSuppressedValue() {
    return this._getBoolFieldValue('runTimeClockSuppressed');
  },

  _getBoolFieldValue(field) {
    const { modalFields } = this.state;

    if (modalFields && typeof modalFields.get(field) === 'boolean') {
      return modalFields.get(field);
    }

    return this._getItem().get(field);
  },

  _getRowIndex() {
    return this.state.rowState.rowIndex;
  },

  _getDurationValue() {
    let { modalFields } = this.state;

    if (
      modalFields &&
      typeof modalFields.get('durationInSeconds') !== 'undefined'
    ) {
      return modalFields.get('durationInSeconds');
    }

    return this.state.rowState.item.get('durationInSeconds');
  },

  _getItem() {
    return this.state.rowState.item;
  },

  _getModalId() {
    return UIRegions.CuesheetItemDuration;
  },

  componentDidUpdate() {
    if (this.state.rowState) {
      ModalActions.show(this._getModalId());
    }
  },
});
